import type { OwnerSpace } from "../../services/spaces.service";
import {
  CALENDAR_SYNC_GROUP_MAX_SPACES,
  CALENDAR_SYNC_THUMBNAIL_PX,
} from "../constants/host-hub-calendar-sync.consts";
import type { RecommendedCardItem } from "../types/model/recommended";
import { pickSpaceThumbnailUrl } from "./cloudinary-image.utils";

const toCalendarSyncItem = ({
  space,
  spaceId,
}: {
  space: OwnerSpace | undefined;
  spaceId: string;
}): RecommendedCardItem => {
  const title = space?.title ?? "";

  return {
    id: spaceId,
    mediaAlt: title,
    mediaUrl: pickSpaceThumbnailUrl({
      images: space?.images,
      size: CALENDAR_SYNC_THUMBNAIL_PX,
    }),
    primaryCtaRoute: `/calendar/${spaceId}`,
    title,
  };
};

/**
 * Maps unsynced space IDs into recommended-card rows using owner-space
 * documents (`title`, `images`) from `GET /v1/spaces/owner/:sso-id`.
 */
export const toCalendarSyncItems = ({
  spaces,
  unsyncedSpaceIds,
}: {
  spaces: OwnerSpace[] | undefined;
  unsyncedSpaceIds: string[] | undefined;
}): RecommendedCardItem[] => {
  const spaceById = new Map((spaces ?? []).map((space) => [space._id, space]));

  return (unsyncedSpaceIds ?? [])
    .slice(0, CALENDAR_SYNC_GROUP_MAX_SPACES)
    .map((spaceId) =>
      toCalendarSyncItem({
        space: spaceById.get(spaceId),
        spaceId,
      }),
    );
};
